import {EVENTS_UPDATE_REQUEST, EVENTS_UPDATE_SUCCESS, EVENTS_UPDATE_FAILURE} from "../../constants/events/update";
import {apiRequest, eventUpdate} from "../../../helpers/api";

export const updateEvent = data => dispatch => {
  dispatch({type: EVENTS_UPDATE_REQUEST});
  const request = () => eventUpdate(data);
  return apiRequest(request, dispatch, EVENTS_UPDATE_SUCCESS, EVENTS_UPDATE_FAILURE);
};